import { render, staticRenderFns } from "./InvolvementTable.vue?vue&type=template&id=306518dc&"
import script from "./InvolvementTable.vue?vue&type=script&lang=js&"
export * from "./InvolvementTable.vue?vue&type=script&lang=js&"
import style0 from "./InvolvementTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports